import { ReactNode } from 'react';
import classNames from 'classnames';

export const DrawerRowValue = ({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) => (
    <span
        className={classNames('text-base font-normal text-primary', className)}
    >
        {children}
    </span>
);
